module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0053.png.77252e94.jpg";